export default "__VITE_ASSET__H5EuUS6M__"